// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"307c6547","116":"39c9d39c","256":"7de90532"}[chunkId] + ".chunk.css";
};